export const API_URL = `https://happy-thoughts-technigo.herokuapp.com/thoughts`
export const API_LIKES_URL = (thoughtId) =>
  `https://happy-thoughts-technigo.herokuapp.com/thoughts/${thoughtId}/like`
